import { useState } from 'react'
import {
  autoUpdate,
  flip,
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from '@floating-ui/react'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { MATCH_CRITERIA_POPOVER_OFFSET } from '../../RentalPortalMatchCriteriaPopover.constants'

export function useRentalPortalMatchCriteriaPopover() {
  const [isOpen, setOpen] = useState(false)

  const {
    context,
    floatingStyles,
    refs: { setFloating, setReference },
  } = useFloating({
    middleware: [offset(MATCH_CRITERIA_POPOVER_OFFSET), flip(), shift()],
    open: isOpen,
    placement: FLOATING_ELEMENT_PLACEMENT.bottomStart,
    whileElementsMounted: autoUpdate,
    onOpenChange: setOpen,
  })

  const { getFloatingProps, getReferenceProps } = useInteractions([
    useClick(context),
    useDismiss(context, { ancestorScroll: true, outsidePress: true }),
    useRole(context, { role: 'dialog' }),
  ])

  return {
    context,
    floatingStyles,
    getFloatingProps,
    getReferenceProps,
    isOpen,
    setFloating,
    setReference,
  }
}
